import { CommonModule } from '@angular/common';
// Angular Imports
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AccountSummaryComponent } from './account-summary.component';

@NgModule({
  imports: [CommonModule],
  declarations: [AccountSummaryComponent],
  exports: [AccountSummaryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AccountSummaryModule {}
